import { render, staticRenderFns } from "./CategoriaFormComponent.vue?vue&type=template&id=e5154f2a&"
import script from "./CategoriaFormComponent.vue?vue&type=script&lang=js&"
export * from "./CategoriaFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports